import D3Throttle from '@utilities/throttle';

export type StickyPluginOptions = {
  stickyClass?: string;
  initialOffset?: number;
};

const defaults: StickyPluginOptions = {
  stickyClass: 'is-sticky',
  initialOffset: 0,
};

export default class StickyPlugin {
  opt: StickyPluginOptions;
  dom: HTMLElement;
  observer: D3Throttle;

  constructor(dom: HTMLElement, o: StickyPluginOptions = {}) {
    this.opt = {
      ...defaults,
      ...o,
    };
    this.dom = dom;
  }

  init() {
    this.observer = new D3Throttle(window, this.onScroll, 100, ['scroll.sticky'], this);
  }

  onScroll = () => {
    this.dom.classList.toggle(this.opt.stickyClass, this.dom.offsetTop > this.opt.initialOffset);
  };
}
